import { dispatch, useReframe } from 'nike-re-framejs';
import React from 'react';

import { fireGAEvent } from '@/analytics';
import RadioButton from '@/common/components/RadioButton';
import i18n from '@i18n';
import { getByDateLabel } from '@/nikeone/components/FilterSlider';
import { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import './results-by-date-dialog.less';
import { changePrematchByDate } from '@/nikeone/handlers';

function ResultsByDateDialog({ data }) {
    const { bettingDays } = data;
    const derefSub = useReframe();
    const byDate = derefSub(['nikeone/filter/byDate']);

    function changeBettingDay(bettingDay) {
        dispatch(changePrematchByDate(bettingDay, false));
        setTimeout(() => PopupNg.dispatcher.close('nikeone/results-by-date-filter'), 500);
        fireGAEvent('Ponuka', 'Kalendar', 'Filter');
    }

    return (
        <>
            <DialogTitle>
                <h2>{i18n('filter.title.offer.time')}</h2>
            </DialogTitle>
            <DialogBody className="results-by-date-list">
                {['ALL', ...bettingDays].map(bettingDay => (
                    <RadioButton
                        key={bettingDay}
                        labelClassName={''}
                        active={byDate === bettingDay}
                        onClick={() => changeBettingDay(bettingDay)}
                    >
                        {getByDateLabel(bettingDay)}
                    </RadioButton>
                ))}
            </DialogBody>
        </>
    );
}

export default ResultsByDateDialog;
